<form
  #googleSso
  method="get"
  [action]="ssoUrl"
>
  <button
    type="button"
    payee-button
    width="wide"
    height="tall"
    color="white"
    [isBorderButton]="true"
    (click)="googleSso.submit()"
  >
    <img
      src="assets/google-g-logo.svg"
      alt="Google"
      class="google-logo"
    />
    {{ "LOGIN.CONTINUE_WITH_GOOGLE" | translate }}
  </button>
</form>
